import { render, staticRenderFns } from "./DonutChart08Template.vue?vue&type=template&id=13060972&scoped=true"
import script from "./DonutChart08Template.vue?vue&type=script&lang=js"
export * from "./DonutChart08Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13060972",
  null
  
)

export default component.exports